// This file was autogenerated with oarepo-tools
import TRANSLATE_EN from "./en/LC_MESSAGES/translations.json";
export const translations = {
  en: { translation: TRANSLATE_EN },
};
